export default __webpack_public_path__ + "static/media/ru-da.5fce2454.svg";